export default "__VITE_PUBLIC_ASSET__4fdee5cd__"